export enum PROJECT_ACTION {
  CLOSE_PROJECT_SUCCESS = 'CLOSE_PROJECT_SUCCESS',
  REOPEN_PROJECT_SUCCESS = 'REOPEN_PROJECT_SUCCESS',
  REOPEN_PROJECT_ERROR = 'REOPEN_PROJECT_ERROR',
  CLOSE_PROJECT_ERROR = 'CLOSE_PROJECT_ERROR',
  REOPEN_PROJECT = 'REOPEN_PROJECT',
  CLOSE_PROJECT = 'CLOSE_PROJECT',
  MEMBERS_TIMESHEET_CLOSED_WARNING = 'MEMBERS_TIMESHEET_CLOSED_WARNING',
  DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS',
  DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR',
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  START_DATE_CONFLICT_ERROR = 'START_DATE_CONFLICT_ERROR',
  ERROR_UPDATING = 'ERROR_UPDATING',
}
